/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { apiClient} from './api'
import { handleError } from './error';
import { RootState } from '../reducers';
import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';

type Thunk = ThunkAction<void, RootState, any, AnyAction>;

export const loadFrameworkByInitiativeId = (initiativeId: string): Thunk => {
  return (dispatch, getState) => {
    const frameworkState = getState().framework;
    if (frameworkState.initiativeId === initiativeId) {
      return;
    }

    dispatch({
      type: actionTypes.LOADING_FRAMEWORK,
      initiativeId: initiativeId
    });

    return apiClient.get('framework-planners/initiativeId/' + initiativeId)
      .then((resp) => {
        dispatch({
          type: actionTypes.LOADED_FRAMEWORK,
          data: resp.data.data,
          initiativeId: initiativeId
        });
      })
      .catch(handleError(dispatch, actionTypes.ERROR_FRAMEWORK))
  };
};
